<template>
<div>
	<p v-if="insideTable && readonly" style="margin:0">{{ localValue ? ((itemText ? localItems.find(c => c.id == localValue)[itemText] : localItems.find(c => c.id == localValue).no +'-' +localItems.find(c => c.id == localValue).name)|| emptyState ): emptyState}}</p>
	<bee-autocomplete
		v-else
		context="material" 
		:action-name="actions.GET"
		:items="localItems"
		:item-text="itemText"
		itemValue="id"
		:label="label"
		v-model="localValue"
		:readonly="readonly"
		:loading="loading"
		:disabled="disabled"
		@blur="$emit('blur')"
		:insideTable="insideTable"
		:rules="rules"
		:multiple = "multiple"
		@keydown-enter-prevent="$emit('keydown-enter-prevent')"
		@keydown-esc-prevent="$emit('keydown-esc-prevent')"
		@keydown.ctrl.down="$emit('keydown-ctrl-down')"
		:empty-state="emptyState"
		ref="BeeMaterialAutocomplete"
		:clearable="clearable"
		:filter="customFilter"
		:hide-details="hideDetails"
		@keydown="$emit('keydown', $event)"
		@keypress="$emit('keypress', $event)"
		@click:clear="$emit('input', value)"
		@change="$emit('change', $event)"
	>
		<template v-slot:selection="{ item, index }">
			<div v-if="multiple">
				<div v-if="index === 0">
					<span>{{ item.name }}</span>
				</div>
				<span
					v-if="index === 1"
					class="grey--text text--darken-2 text-caption ms-2"
					>
					(+{{  localValue.length - 1 }})
				</span>
			</div>
			<div v-else>
				{{ itemText ? item[itemText] :  item.no + '-' + item.name }}
			</div>
		</template>

		<template v-slot:item="data">
			<v-list-item
				:class="typeof itemColor === 'function' ? itemColor(data.item) : (itemColor || null)"
				v-on="data.on"
				v-bind="data.attrs"
			>
				<v-list-item-action v-if="multiple">
					<v-checkbox v-model="data.attrs.inputValue" />
				</v-list-item-action>
				{{ itemText ? data.item[itemText] : data.item.no + '-'+ data.item.name }}
				<v-spacer v-if="!!withBalance"></v-spacer>
				<bee-material-amount-label :with-color="true" v-if="!!withBalance" :value="getBalance(data)" :show-zeros-values="true"></bee-material-amount-label>
			</v-list-item>
		</template>
	</bee-autocomplete>
</div>
</template>
<script>
import actions from "../../../permissions/actions-names.js"
export default {
props: [
	"rules", "value", "items", "label", "itemText", "insideTable", "readonly", "emptyState", "disabled", "clearable", "withBalance", "hideDetails", 'itemColor', 'multiple',"loading"
],
name: "BeeMaterialAutocomplete",
data: () => ({
	actions,
}),
computed: {
    localValue: {
		get: function () {
			return this.value;
		},
		set: function (value) {
			this.$emit("input", value);
		},
	},
	localItems: {
		get: function () {
			return this.items;
		},
		set: function (value) {
			this.items = value
		},
	},
	valid: {
		get() { return this.$refs.BeeMaterialAutocomplete.valid },
		set(val) { this.$refs.BeeMaterialAutocomplete.valid = val },
	},
	hasFocused: {
		get() { return this.$refs.BeeMaterialAutocomplete.hasFocused },
		set(val) { this.$refs.BeeMaterialAutocomplete.hasFocused = val },
	}
},
methods: {
    customFilter (item, queryText, itemText) {
		const filter = itemText ? itemText : item.no + '-' + item.name
		const searchText = queryText.toLocaleLowerCase()
		return ( 
			filter.toLocaleLowerCase().indexOf(searchText) > -1 
		)
    },
	getBalance(data){
		return data.item?.balance
	},
	focus() { this.$refs.BeeMaterialAutocomplete.focus(); },
	validate() { return this.$refs.BeeMaterialAutocomplete.validate(); },
	resetValidation() { this.$refs.BeeMaterialAutocomplete.resetValidation(); }
},
};
</script>
<style>
</style>